import { FeatureFlagKey } from '@/features/feature-flags/presentation/types/feature-flag-key';
import { Configuration } from './types';

/**
 * Internal DEV environment configuration.
 * This points at the DEV environment (i.e. all services referenced below are running/hosted in the DEV environment).
 */
export const config: Partial<Configuration> = {
  portalApi: 'https://ewa.api.dev.portal.genvis.com/v1',
  portalEwaBffApi: 'https://api.dev.portal.genvis.com/ewa/v1',
  mapbox: {
    overlaysTileSet: 'mapbox://robgenvis.ewa-overlays-dev',
    overlayTileSetLayers: {
      dfesRegions: 'dfes-regions-tileset-layer-dev',
      lga: 'lga-tileset-layer-dev',
      lgaCentres: 'lga-centres-tileset-layer-dev',
      pastoralStations: 'pastoral-stations-tileset-layer-dev',
    },
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://dev.kudo.genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://dev.kudo.genvis.com/assets/icons/map/pins/40x40',
  },
  geospatialBucket: 'https://d1ro7pgfug9vfo.cloudfront.net',
  windTileBaseUrl: 'https://d1fhi4ybv9p5ec.cloudfront.net',
  externalTileBaseUrl: 'https://decbn2efquael.cloudfront.net',
  webTemplateStyleSheetUrl: 'https://dev.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  featureFlags: {
    [FeatureFlagKey.EnableMyEmergencyPlan]: true,
  },
  firebaseConfig: {
    apiKey: 'AIzaSyBIk_mAn8ACPEVLiHDQ_PHuafTxw6sc_QU',
    authDomain: 'ewa-web-dev.firebaseapp.com',
    projectId: 'ewa-web-dev',
    storageBucket: 'ewa-web-dev.firebasestorage.app',
    messagingSenderId: '475247624144',
    appId: '1:475247624144:web:f725e79024a35d5b97c3d5',
    measurementId: 'G-KS7PWWHYC0',
  },
  recaptcha: {
    siteKey: '6Lf73LwrAAAAAO3tA0h4uSB0qSNpyTbg2LHC1Ezj',
  },
  googleTagManager: {
    containerId: 'GTM-PZWL43P8',
  },
  environment: 'dev',
};
